function getChargeOnDisplay (chargeOn) {
  return this.chargeOnList[chargeOn] || chargeOn
}

export default {
  data () {
    return {
      chargeOnList: {
        'PER_BOOK': '每一册',
        'PER_ORDER': '每个订单'
      }
    }
  },
  methods: {
    getChargeOnDisplay
  }
}
